// below are the imports
import { Components } from '@plusscommunities/pluss-core-web'; // for production
// import { Components } from '../pluss-extension-web/pluss-core/src'; // for development

// below are the components that have been moved to the Core module
export const AddButton = Components.AddButton;
export const AnalyticsFilter = Components.AnalyticsFilter;
export const Attachment = Components.Attachment;
export const AudienceSelector = Components.AudienceSelector;
export const Button = Components.Button;
export const CheckBox = Components.CheckBox;
export const DatePicker = Components.DatePicker;
export const DropdownInput = Components.DropdownInput;
export const FileInput = Components.FileInput;
export const GenericInput = Components.GenericInput;
export const Header = Components.Header;
export const ImageInput = Components.ImageInput;
export const MoreMenu = Components.MoreMenu;
export const OptionsSection = Components.OptionsSection;
export const OverlayPage = Components.OverlayPage;
export const OverlayPageBottomButtons = Components.OverlayPageBottomButtons;
export const OverlayPageContents = Components.OverlayPageContents;
export const OverlayPageSection = Components.OverlayPageSection;
export const PageTitle = Components.PageTitle;
export const P60Icon = Components.P60Icon;
export const Popup = Components.Popup;
export const ProfilePic = Components.ProfilePic;
export const RadioButton = Components.RadioButton;
export const SVGIcon = Components.SVGIcon;
export const SuccessPopup = Components.SuccessPopup;
export const Tag = Components.Tag;
export const Text = Components.Text;
export const TextFormatPopup = Components.TextFormatPopup;
export const TimePicker = Components.TimePicker;
export const UserListing = Components.UserListing;

// below are components that haven't been moved to the Core module yet
export * from './AddOption';
export * from './AddUserPopup';
export * from './AppWrapper';
export * from './ConfirmActions';
export * from './Dropdown';
export * from './FilterMenu';
export * from './InputGroup';
export * from './InputGroupNew';
export * from './LinkedContentSelector';
export * from './MainMenuGroup';
export * from './MainMenuItem';
export * from './NumberSpinner';
export * from './PageContainer';
export * from './SideMenu';
export * from './SideNav';
export * from './SideNavItem';
export * from './Site';
export * from './Spinner';
export * from './Tabs';
export * from './ToggleButton';
export * from './UserRefresh';
export * from './WarningPopup';
